import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Card, DataTable, Link } from '@shopify/polaris';

import ItemLink from '@presentational/ItemLink';

const propTypes = {
  rows: PropTypes.array.isRequired,
}

const defaultProps = {

}

const SaleReportStats = (props) => {

  const buildRows = useCallback( () => props.rows.map((item) => {
    return [
      <ItemLink url={ item[3] } content={ item[0] } />, 
      item[1], 
      item[2], 
    ]
  }), [props.rows.length]);

  const rowsWithLink = buildRows()

  return (
    <Card title={ I18n.t("dashboard.sale_report_stats") } >
      <DataTable
        rows={rowsWithLink}
        headings={[]}
        columnContentTypes={['text', 'text', 'text' ]}
      />
    </Card>
  )
};

SaleReportStats.propTypes = propTypes;
SaleReportStats.defaultProps = defaultProps;

export default SaleReportStats;